import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as actions from '../../store/actions';
import { Box, Dialog, makeStyles } from '@material-ui/core';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import KapinuaColorsList from '../../components/KapinuaColors/KapinuaColors.List';

const useStyles = makeStyles((theme) => ({
    dialog: {
        maxWidth: '450px',
        padding: '10px',
    },
}));

interface Props {
    activeColor?: string;
    open: boolean;
    onClose: () => void;
    onChange: (color: string) => void;
    externalActiveColor?: string | null;
}

export interface IColor {
    hex: string;
    rgb: string;
}

const KapinuaColors: React.FC<Props> = (props) => {
    const classes = useStyles();

    const { activeColor, externalActiveColor, open, onClose, onChange } = props;
    const dispatch = useDispatch();

    const { data, loading } = useTypedSelector(
        (state) => state.kapinuaColors.loadColors
    );

    useEffect(() => {
        if (data === null && !loading) {
            dispatch(actions.loadKapinuaColors());
        }

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnChange = (hex: string, e: any) => {
        onChange(hex);
        onClose();
    };

    const showSpinner = data === null || loading;
    return (
        <Dialog onClose={onClose} open={open}>
            {showSpinner && <CircularProgress />}
            {!showSpinner && (
                <Box className={classes.dialog}>
                    <KapinuaColorsList
                        handleOnChange={handleOnChange}
                        colors={data}
                        activeColor={activeColor}
                        externalActiveColor={externalActiveColor}
                    />
                </Box>
            )}
        </Dialog>
    );
};

export default KapinuaColors;
